module.exports = __webpack_public_path__ + "static/media/CNB.68d9378e.svg";